import { createAsyncThunk } from '@reduxjs/toolkit';
import { getCardImageUploadSignedUrl } from '../services/getCardImageUploadSignedUrl.service';
import { patchUpdateCard } from '../services/patchUpdateCard.service';
import { compressCardImage } from '../utils/compressCardImage.util';
import { selectUserActiveEmployerInfo } from 'store/user/selectors.js/user.selectors';
import Axios from 'axios';

export const updateCard = createAsyncThunk(
  'cards/updateCard',
  async (
    { cardId, cardUserId, cardAttributes, cardImage, cardImage2 },
    { getState }
  ) => {
    if (cardImage) {
      const compressedImage = await compressCardImage(cardImage);
      const fileType1 = compressedImage?.type;

      const imageUploadSignedUrl = await getCardImageUploadSignedUrl(
        cardUserId,
        cardId,
        fileType1
      );

      if (imageUploadSignedUrl && compressedImage) {
        const options = {
          headers: {
            'Content-Type': fileType1,
          },
        };

        await Axios.put(imageUploadSignedUrl, compressedImage, options);
      }
    }

    if (cardImage2) {
      const compressedImage = await compressCardImage(cardImage2);
      const fileType2 = compressedImage?.type;

      const imageUploadSignedUrl = await getCardImageUploadSignedUrl(
        cardUserId,
        `${cardId}_2`,
        fileType2
      );

      if (imageUploadSignedUrl && compressedImage) {
        const options = {
          headers: {
            'Content-Type': fileType2,
          },
        };

        await Axios.put(imageUploadSignedUrl, compressedImage, options);
      }
    }

    const activeEmployerInfo = selectUserActiveEmployerInfo(getState());

    const cardType = cardAttributes.type;

    const isCustomCompetencyCardType = cardAttributes.type.includes(
      'CUSTOM_BUSINESS_COMPETENCY'
    );

    const effectiveCardType = isCustomCompetencyCardType
      ? cardType.split('#')[0]
      : cardType;

    const effectiveCardName = isCustomCompetencyCardType
      ? cardType.split('#')[1]
      : undefined;

    const cardData = {
      ...cardAttributes,
      type: effectiveCardType,
      name: effectiveCardName,
    };

    const updatedCard = await patchUpdateCard({
      cardId,
      cardData,
      activeEmployerInfo,
    });
    return updatedCard;
  }
);
